import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Avisos from "@/pages/Avisos";
import WorkOrders from "@/pages/WorkOrders";
import Technicians from "@/pages/Technicians";
import Calendar from "@/pages/Calendar";
import Audit from "@/pages/Audit";
import Settings from "@/pages/Settings";
import MapOperativo from "@/pages/MapOperativo";
import Quotes from "@/pages/Quotes";
import Invoices from "@/pages/Invoices";
import Team from "@/pages/Team";
import Inventory from "@/pages/Inventory";
import Suppliers from "@/pages/Suppliers";
import Purchases from "@/pages/Purchases";
import PreventiveMaintenance from "@/pages/PreventiveMaintenance";
import Billing from "@/pages/Billing";
import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "@/lib/api";
import Landing from "@/pages/Landing";

function PlanRoute({ children, minPlan = "starter" }) {
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  const PLAN_LEVELS = {
    starter: 1,
    professional: 2,
    business: 3,
  };

  useEffect(() => {
    api
      .get("/subscription")
      .then((res) => {
        setSubscription(res.data);
      })
      .catch((error) => {
        console.error("Error cargando suscripción:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        Cargando...
      </div>
    );
  }

  const currentPlan = subscription?.plan || "trial";

  // Durante la prueba gratuita tiene acceso a todo.
  if (currentPlan === "trial") {
    return children;
  }

  const hasAccess =
    (PLAN_LEVELS[currentPlan] || 0) >=
    (PLAN_LEVELS[minPlan] || 0);

  if (!hasAccess) {
    return <Navigate to="/facturacion-navirox" replace />;
  }

  return children;
}


function App() {
  return (
    <div className="App">
  <AuthProvider>
    <BrowserRouter>
      <Routes>
        {/* WEB PÚBLICA */}
        <Route path="/" element={<Landing />} />

        {/* ACCESO */}
        <Route path="/login" element={<Login />} />

        {/* SOFTWARE NAVIROX */}
        <Route
          path="/panel"
          element={
            <ProtectedRoute>
              <PlanRoute minPlan="starter">
                <Dashboard />
              </PlanRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/avisos"
          element={
            <ProtectedRoute>
              <PlanRoute minPlan="starter">
                <Avisos />
              </PlanRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/ordenes"
          element={
            <ProtectedRoute>
              <PlanRoute minPlan="starter">
                <WorkOrders />
              </PlanRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/clientes"
          element={
            <ProtectedRoute>
              <PlanRoute minPlan="starter">
                <Clients />
              </PlanRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/tecnicos"
          element={
            <ProtectedRoute>
              <PlanRoute minPlan="starter">
                <Technicians />
              </PlanRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/calendario"
          element={
            <ProtectedRoute>
              <PlanRoute minPlan="starter">
                <Calendar />
              </PlanRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/quotes"
          element={
            <ProtectedRoute>
              <PlanRoute minPlan="starter">
                <Quotes />
              </PlanRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/facturas"
          element={
            <ProtectedRoute>
              <PlanRoute minPlan="starter">
                <Invoices />
              </PlanRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/empresa"
          element={
            <ProtectedRoute>
              <PlanRoute minPlan="starter">
                <Settings />
              </PlanRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/equipo"
          element={
            <ProtectedRoute>
              <PlanRoute minPlan="starter">
                <Team />
              </PlanRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/mapa"
          element={
            <ProtectedRoute>
              <PlanRoute minPlan="professional">
                <MapOperativo />
              </PlanRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/inventario"
          element={
            <ProtectedRoute>
              <PlanRoute minPlan="professional">
                <Inventory />
              </PlanRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/proveedores"
          element={
            <ProtectedRoute>
              <PlanRoute minPlan="professional">
                <Suppliers />
              </PlanRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/compras"
          element={
            <ProtectedRoute>
              <PlanRoute minPlan="professional">
                <Purchases />
              </PlanRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/mantenimiento"
          element={
            <ProtectedRoute>
              <PlanRoute minPlan="professional">
                <PreventiveMaintenance />
              </PlanRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/auditoria"
          element={
            <ProtectedRoute>
              <PlanRoute minPlan="business">
                <Audit />
              </PlanRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/facturacion-navirox"
          element={
            <ProtectedRoute>
              <Billing />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>

        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;